import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, BookMarked, FlaskConical, Feather, Check } from 'lucide-react';
import { PROGRAMS } from '../data/mock';

const iconMap = { BookOpen, BookMarked, FlaskConical, Feather };

export default function Programs() {
  return (
    <div className="fade-in">
      <section className="coral-gradient text-white relative overflow-hidden">
        <div className="absolute inset-0 dotted-bg opacity-60" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28">
          <div className="text-white/90 text-xs font-semibold uppercase tracking-[0.18em]">Our Programs</div>
          <h1 className="font-serif font-semibold text-5xl md:text-6xl mt-4 leading-[1.05] max-w-4xl">
            Structured academic programs from <span className="gold-text italic">Class 5 to 12.</span>
          </h1>
          <p className="mt-6 text-white/90 text-lg max-w-2xl">Board-aligned preparation for ICSE, CBSE & ISC — built around concept clarity, regular assessment, and individual mentoring.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid md:grid-cols-2 gap-6">
          {PROGRAMS.map((p) => {
            const Icon = iconMap[p.icon];
            return (
              <div key={p.title} className="bg-white rounded-3xl p-8 border border-orange-100 smooth card-hover">
                <div className="flex items-start justify-between">
                  <div className="w-14 h-14 rounded-2xl bg-coral-light text-coral flex items-center justify-center">
                    <Icon className="w-7 h-7" />
                  </div>
                  <div className="text-xs uppercase tracking-wider text-stone-500 font-semibold">{p.badge}</div>
                </div>
                <h3 className="font-serif font-semibold text-2xl mt-5">{p.title}</h3>
                {p.tag && <div className="text-xs text-amber-700 bg-amber-100 inline-block px-2.5 py-1 rounded-full mt-2 font-medium">{p.tag}</div>}
                <p className="text-stone-600 mt-4 leading-relaxed">{p.desc}</p>
                <ul className="mt-5 space-y-2.5">
                  {p.bullets.map((b) => (
                    <li key={b} className="flex gap-2.5 items-start text-sm text-stone-700">
                      <Check className="w-4 h-4 text-coral mt-0.5 shrink-0" /> {b}
                    </li>
                  ))}
                </ul>
                <Link to="/admissions" className="inline-flex items-center gap-2 mt-6 text-coral font-semibold hover:gap-3 smooth">
                  Apply for this Program <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
